import moment from "moment";


export const getTimeDifferenceInMinutes = (start, end) => {
    if (!start && !end) {
        return 0;
    }
    const startMoment = moment(start, "YYYY-MM-DD HH:mm:ss.SSS");
    const endMoment = moment(end, "YYYY-MM-DD HH:mm:ss.SSS");

    return endMoment.diff(startMoment, "minutes");
}

export const getUniqueRooms = (data) => {
    const roomSet = new Set();

    data.forEach((entry) => {
        if (entry.room_name) {
            // entry.rooms.forEach((room) => {
            roomSet.add(entry.room_name);
            // });
        }
    });

    return Array.from(roomSet);
};

export const groupEventsByHour = (events, allRooms, roomsByIdandName, date = "2025-05-05") => {
    const hourBlocks = [];
    // console.log('::::events, allRooms,:::', { events, allRooms })

    const formatTime = (dateObj) => {
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };
    for (let hour = 8; hour < 20; hour++) {
        const startBlock = new Date(`${date}T${String(hour).padStart(2, '0')}:00:00`);
        const endBlock = new Date(`${date}T${String(hour + 1).padStart(2, '0')}:00:00`);
        const hourEntry = {
            key: `${hour - 7}`,
            time: formatTime(startBlock),
            rooms: []
        };
        let roomEvents
        allRooms.forEach((roomId, idx) => {
            roomEvents = events.filter(event => {
                let start, end;
                if (event.type == 'appointment') {
                    start = new Date(event.start_time);
                    end = new Date(event.end_time);
                }
                else if (event.type == 'spacer_and_lunch') {
                    start = new Date(event.start_time);
                    end = new Date(event.end_time);
                }
                else {
                    start = new Date(`${event.date}T${event.start_time.slice(0, 8)}`);
                    end = new Date(`${event.date}T${event.end_time.slice(0, 8)}`);
                }

                return event.room_id == roomId && start < endBlock && end > startBlock;
            });

            const formattedEvents = roomEvents.map((event) => {
                if (event.type == 'appointment') {
                    const time = new Date(event.appointment_starttime).toTimeString().slice(0, 5);
                    return {
                        event: event,
                        type: 'appointment'
                    };
                } else if (event.type == 'spacer_and_lunch') {
                    return {
                        event: event,
                        type: 'spacer_and_lunch'
                    };
                } else {
                    return {
                        event: event.name.toUpperCase(),
                        type: event.name.toUpperCase()
                    };
                }
            });
            hourEntry.rooms.push({
                roomName: roomsByIdandName && roomsByIdandName[roomId] ? roomsByIdandName[roomId] : '',
                event: formattedEvents,
                type: ""
            });
        });
        hourBlocks.push(hourEntry);
        // hourEntry.rooms = []
    }

    return hourBlocks;
}

export const getAppointmentDuration = (startTime = null, endTime = null) => {
    if (startTime && endTime) {
        const startMoment = moment(startTime, "YYYY-MM-DD HH:mm:ss.SSS");
        const endMoment = moment(endTime, "YYYY-MM-DD HH:mm:ss.SSS");
        return endMoment.diff(startMoment, "minutes");
    } else {
        return '';
    }
}
export const formatTimeRange = (start_time, end_time) => {
    if (!start_time || !end_time) return "";
    const start = moment(start_time, "YYYY-MM-DD HH:mm:ss.SSS");
    const end = moment(end_time, "YYYY-MM-DD HH:mm:ss.SSS");
    return { start: `${start.format("h:mm A")}`, end: `${end.format("h:mm A")}` };
};

function getRoundedStartTime(interval = 15) {
    const now = new Date();
    const baseTime = new Date();
    baseTime.setHours(8, 0, 0, 0); // Default to 8:00 AM

    if (now < baseTime) return baseTime;

    const minutes = now.getMinutes();
    const roundedMinutes = Math.ceil(minutes / interval) * interval;
    now.setMinutes(roundedMinutes);
    now.setSeconds(0);
    now.setMilliseconds(0);
    return now;
}
export function generateTimeSlotsFromNow({
    startTime = null,
    endHour = '20:00',
    interval = 15,
    date = new Date()
} = {}) {
    // Parse 'Thursday, 15th May, 2025' or fallback to default parsing
    const parsedDate = moment(date, 'dddd, Do MMMM, YYYY', true);
    const baseDate = parsedDate.isValid()
        ? parsedDate.startOf('day')
        : moment(date).startOf('day');

    let current;

    if (startTime) {
        const [hours, minutes] = startTime.split(':').map(Number);
        current = baseDate.clone().set({ hour: hours, minute: minutes, second: 0, millisecond: 0 });
    } else {
        current = moment(getRoundedStartTime(interval, baseDate.toDate()));
    }
    // console.log('current:::', endHour)
    let end
    if (endHour) {
        const [hours, minutes] = endHour.split(':').map(Number);
        end = baseDate.clone().set({ hour: hours, minute: minutes ?? 0, second: 0, millisecond: 0 });
    }
    const slots = [];

    while (current.isSameOrBefore(end)) {
        slots.push(current.format('HH:mm'));
        current.add(interval, 'minutes');
    }

    return slots;
}

export const addfifteenMinutes = (dateString) => {
    return moment(dateString, "YYYY-MM-DD HH:mm:ss.SSS")
        .add(15, 'minutes')
        .format("YYYY-MM-DD HH:mm:ss.SSS");
};

export const subtractFifteenMinutes = (dateString) => {
    return moment(dateString, "YYYY-MM-DD HH:mm:ss.SSS")
        .subtract(15, 'minutes')
        .format("YYYY-MM-DD HH:mm:ss.SSS");
};

export const capitalizeFirst = (str = '') => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export const filterByNonGpProductId = (products, targetId) => {
    return products.filter(product => product.non_gp_product_id == targetId) ?? '';
}
export const capitalizeWords = (sentence) => {
    return sentence
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}